let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4NTvA")).then(() => parcelRequire('4MZE8'));